<template>
  <div class="pgStyle" :style="{ fontSize: fonts.font18 + 'px' }">
    <b-btn
      v-b-toggle.shares class="btnCollapse"
      :style="{ fontSize: fonts.font26 + 'px' }">
      {{ shares.header }}
    </b-btn>
    <b-collapse visible id="shares" class="bCard">
      <div class="bCard">
        <div class="groupHeader">
          <span class="grHead" style="width: 50%">Description</span>
          <span class="grHead" style="width: 25%">Available</span>
          <span class="grHead" style="width: 25%">Balance</span>
        </div>
        <div v-for="sh in shares.sar" :key="sh.key">
          <div>
            <div v-show="!sh.isActive"
                 :style="sh.style"
                 @click="toggleShare(sh)" >
              <div class="groupSection"
                  :style="sh.highlight"
                  @mouseenter="mouseEnter(sh)"
                  @mouseleave="mouseExit(sh)">
                <div class="grPrime" style="width: 50%">{{ sh.desc }}</div>
                <div class="grRight" style="width: 25%">{{ sh.$avail }}</div>
                <div class="grRight" style="width: 25%">{{ sh.$bal }}</div>
              </div>
            </div>
            <div v-show="sh.isActive" class="detailBox" :style="sh.style">
              <div class="groupSection" :style="sh.style" @click="toggleShare(sh)">
                <div class="grPrime" style="width: 50%">{{ sh.desc }}</div>
                <div class="grRight" style="width: 25%">{{ sh.$avail }}</div>
                <div class="grRight" style="width: 25%">{{ sh.$bal }}</div>
              </div>
              <div v-show="sh.isActive" :style="sh.style" @click="clickDetailBox(sh)">
                <b-button-group id="btnGroup">
                  <b-button id="btnHist"
                            @click="doHistory(sh)">
                    Show History
                  </b-button>
                  <b-button id="btnXfer"
                            @click="doXfer(sh)">
                    Transfer Funds
                  </b-button>
                  <b-button id="btnClose"
                            @click="toggleShare(sh)">
                    Close
                  </b-button>
                </b-button-group>
                <div v-show="!sh.isCert" class="detailGridBox"> <!-- Detail for Normal Share -->
                  <div class="detailItem">
                    <!-- <div class="ddLeft">Share Type:</div> -->
                    <div class="ddCenter">{{ sh.desc }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Current Balance:</div>
                    <div class="ddRight">{{ sh.$bal }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">YTD Dividends:</div>
                    <div class="ddRight">{{ sh.$ytd }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Hold Amount:</div>
                    <div class="ddRight">{{ sh.$plg }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Available:</div>
                    <div class="ddRight">{{ sh.$avail }}</div>
                  </div>
                </div> <!-- End of Norm Share -->
                <div v-show="sh.isCert"> <!-- Detail for Cert -->
                  <div class="certDetail"> <!-- start of cert top -->
                    <div class="detailItem">
                      <div class="ddLeft">Certificate Number:</div>
                      <div class="ddRight">{{ sh.number }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Original Balance:</div>
                      <div class="ddRight">{{ sh.$orgBal }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Term (months):</div>
                      <div class="ddRight">{{ sh.term }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Annual Dividend Rate:</div>
                      <div class="ddRight">{{ sh.apr }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Effective Compound Rate:</div>
                      <div class="ddRight">{{ sh.effRate }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">YTD Dividends:</div>
                      <div class="ddRight">{{ sh.$ytd }}</div>
                    </div>
                  </div> <!-- end of cert top -->
                  <div class="certDetail"> <!-- start of cert bottom -->
                    <div class="detailItem">
                      <div class="ddLeft">Current Balance:</div>
                      <div class="ddRight">{{ sh.$bal }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">IRA Type:</div>
                      <div class="ddRight">{{ sh.iraType }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Created Date:</div>
                      <div class="ddRight">{{ sh.orgDate }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Maturity Date:</div>
                      <div class="ddRight">{{ sh.matDate }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Projected Total Dividend:</div>
                      <div class="ddRight">{{ sh.$matDiv }}</div>
                    </div>
                    <div class="detailItem">
                      <div class="ddLeft">Post Dividends To:</div>
                      <div class="ddRight">{{ sh.destAcct }}</div>
                    </div>
                  </div> <!-- end of cert bottom -->
                </div> <!-- end of Detail for Cert -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  name: 'shareSummary',
  data() {
    return {
      updateCount: 0,
      font: 'small',
      fontSize: 14,
      rowHeight: 26,
      h: 0,
      w: 0,
      timeOutDoubleClick: 0,
    };
  },
  watch: {
    Scc() {
      this.$forceUpdate();
    },
    myTenthSecond() {
      if (this.timeOutDoubleClick > 0) this.timeOutDoubleClick -= 1;
    },
  },
  computed: {
    Scc() {
      return this.$store.getters.getScc;
    },
    shares() {
      return this.$store.getters.getShares;
    },
    winSize() {
      return this.$store.getters.getWinSize;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    trHigh() {
      return this.$store.getters.getTrHigh;
    },
    myTenthSecond() {
      return this.$store.getters.getMyTenth;
    },
  },
  methods: {
    doHistory(sh) {
      this.$store.commit('updateSearchList'); // So dropdown list of saved searches works
      this.$store.commit('setSearchDesc', ''); // No search name
      const ahInfo = {};
      ahInfo.cun = this.cun;
      ahInfo.acct = this.member.acct;
      ahInfo.share = sh.type;
      ahInfo.quan = 21;
      ahInfo.maxTr = this.trHigh;
      ahInfo.option = 0;
      ahInfo.note = 0;
      ahInfo.desc = sh.desc;
      this.$store.commit('initHist', ahInfo);
    },
    doXfer(sh) {
      const xfInfo = {};
      xfInfo.cun = this.cun;
      xfInfo.acct = this.member.acct;
      xfInfo.type = sh.type;
      xfInfo.share = sh.type;
      xfInfo.note = 0;
      xfInfo.amount = 0;
      xfInfo.desc = sh.desc;
      this.$store.commit('initXfer', xfInfo);
    },
    mouseEnter(sh) {
      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.style = 'background-color: green; color: white';
      this.$store.commit('setShareHighlight', shInfo);
    },
    mouseExit(sh) {
      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.style = sh.style;
      this.$store.commit('setShareHighlight', shInfo);
    },
    clickDetailBox(sh) {
      if (this.timeOutDoubleClick > 0) {
        this.doHistory(sh);
      }
      // utl.diag(`X: ${event.offsetX}  Y: ${event.offsetY} type: ${sh.type}`);
    },
    toggleShare(sh) {
      if (this.timeOutDoubleClick > 0) {
        this.doHistory(sh);
        return;
      }
      if (sh.isActive === false) {
        this.timeOutDoubleClick = 4;
        // utl.diag(`Set timeOutDoubleClick=${this.timeOutDoubleClick}`);
      } // 4 tenths second to do 2nd click

      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.note = 0;
      shInfo.isActive = !sh.isActive;
      // shInfo.isActive = true;
      this.$store.commit('setActiveShare', shInfo);
      this.$forceUpdate();
      let myShow = 'hide';
      if (sh.isActive) myShow = 'show';
      this.writeDiag(`toggleShare = ${sh.type} ${myShow}`);
      this.$store.commit('resetServerTimeout', shInfo);
    },
    diag(msg) {
      this.$store.commit('showDiag', msg);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
  },
};
</script>

<style scoped>
  .pgStyle {

  }
  .bCard {
    padding: 4px;
    margin: 0px;
    width: 100%;
    border: solid 1px black;
  }
  .btnCollapse {
    display: inline-block;
    padding: 0px;
    width: 100%;
    background-color: lightgray;
    color: black;
    font-weight: bold;
    border: solid 2px black;
  }
  .groupHeader {
    display: inline-flex;
    padding: 0px;
    width: 100%;
  }
  .groupSection {
    display: inline-flex;
    vertical-align: center;
    vert-align: middle;
    padding: 0px;
    width: 100%;
    height: 35px;
    cursor: pointer;
  }
  .grHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
  }
  .grPrime {
    /* display: inline-flex; */
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;
    text-decoration: underline;
    border: dotted 1px lightgray;
  }
  .grLeft {
    text-wrap: avoid;
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    height: 30px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .grRight {
    text-align: right;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .detailBox {
    width: 100%;
    border: solid 4px green;
    padding: 0px;
    padding-bottom: 8px;
  }
  .detailGridBox {
    width: 100%;
    max-width: 500px;
    display: inline-block;
    horiz-align: center;
    border: solid 2px black;
    background-color: white;
  }
  .certDetail {
    width: 100%;
    max-width: 400px;
    display: inline-block;
    horiz-align: center;
    border: solid 2px black;
    background-color: white;
  }
  .detailItem {
    width: 100%;
    /* max-width: 500px; */
    display: inline-flex;
    horiz-align: left;
    border: dotted 1px gray;
  }
  .ddCenter {
    text-align: center;
    width: 100%;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;

  }
  .ddLeft {
    text-align: left;
    width: 70%;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;

  }
  .ddRight {
    text-align: right;
    width: 30%;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
  }
  #btnGroup {
    display: inline-block;
    width: 100%;
  }
  #btnHist {
    padding: 0px;
    margin: 1px;
    width: 120px;
    height: 35px;
    background: green;
    color: white;
    font-weight: bold;
  }
  #btnXfer {
    padding: 0px;
    margin: 1px;
    width: 130px;
    height: 35px;
    background: green;
    color: white;
    font-weight: bold;
  }
  #btnClose {
    padding: 0px;
    margin: 1px;
    width: 50px;
    height: 35px;
    font-size: 12px;
    background: red;
    color: black;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/z-shareSummary.vue